import { Base } from '@studiometa/js-toolkit';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';

/**
 * @typedef {{}} CustomScrollBarProps
 */

/**
 * CustomScrollBar CustomScrollBar.
 * @augments {Base<CustomScrollBarProps>}
 */
export default class CustomScrollBar extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'CustomScrollBar',
  };

  /**
   *
   */
  mounted() {
    new SimpleBar(this.$el, { autoHide: false });
  }
}
